import { mergeClasses } from '@/utils/style';
import React from 'react';

interface LabelProps {
	title: string | React.ReactNode;
	className?: string;
}

export const Badge = ({ className, title }: LabelProps): React.JSX.Element => {
	return (
		<span
			className={mergeClasses(
				'rounded-full bg-blue-500 px-3 py-1 text-center text-sm font-semibold whitespace-nowrap text-white',
				className
			)}
		>
			{title}
		</span>
	);
};
